import { useState } from 'react'
import { SmartForm } from '../../components/formFields/Form'
import { PasswordField } from '../../components/formFields/password/Password.component'
import { Spinner } from '../../components/spinner/Spinner.component'
import { api } from '../../data/api'
import toast from 'react-hot-toast'
import { AxiosError } from 'axios'
import { useNavigate } from 'react-router-dom'
import { copyJson } from '../../helpers/general.helper'

export const ChangePassPage = () => {
	const [loading, setLoading] = useState(false)
	const [errors, setErrors] = useState<Record<string, string | undefined>>({})
	const navigate = useNavigate()

	const [formData, setFormData] = useState<{
		passwordOld: string
		passwordNew: string
		passwordConfirm: string
	}>({
		passwordOld: '',
		passwordNew: '',
		passwordConfirm: ''
	})

	const validateForm = () => {
		const newErrors = errors === undefined ? {} : copyJson(errors)
		if (!formData.passwordOld) newErrors.passwordOld = 'La contraseña actual es obligatoria'
		if (!formData.passwordNew) newErrors.passwordNew = 'La nueva contraseña es obligatoria'
		if (!formData.passwordConfirm) newErrors.passwordConfirm = 'La confirmación de contraseña es obligatoria'
		if (formData.passwordNew !== formData.passwordConfirm) newErrors.passwordConfirm = 'Las contraseñas no coinciden'
		if (!formData.passwordNew?.length || formData.passwordNew.length < 8 || formData.passwordNew.length > 12) newErrors.passwordNew = 'La contraseña debe tener entre 8 y 12 characteres'

		setErrors(newErrors)
		return Object.keys(newErrors).length === 0
	}

	const handleSubmit = async () => {
		if (!validateForm()) return
		setLoading(true)
		try {
			await api.post('/api/authm/changepass', {
				oldPassword: formData.passwordOld,
				newPassword: formData.passwordNew,
			})

			toast.success('Contraseña cambiada correctamente')
			navigate('/med/dashboard')
		} catch (error) {
			console.error("### error", error)
			toast.error(error instanceof AxiosError ? error.response?.data?.message :'Error cambiando la contraseña')
		}
	}

	if (loading) return <Spinner />

	return (
		<SmartForm
			title="Cambiar Contraseña"
			onSubmit={handleSubmit}
			confirmButtonLabel="Cambiar"
		>
			<PasswordField
				label="Contraseña Actual"
				value={formData.passwordOld}
				onChange={(value) => {
					setFormData({...formData, passwordOld: value})
					if (errors.passwordOld) setErrors({...errors, passwordOld: undefined})
				}}
				error={errors.passwordOld}
			/>
			<PasswordField
				label="Nueva Contraseña"
				value={formData.passwordNew}
				onChange={(value) => {
					setFormData({...formData, passwordNew: value})
					if (errors.passwordNew) setErrors({...errors, passwordNew: undefined})
				}}
				error={errors.passwordNew}
			/>
			<PasswordField
				label="Confirmar Contraseña"
				value={formData.passwordConfirm}
				onChange={(value) => {
					setFormData({...formData, passwordConfirm: value})
					if (errors.passwordConfirm) setErrors({...errors, passwordConfirm: undefined})
				}}
				error={errors.passwordConfirm}
			/>
		</SmartForm>
	)
}